import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoaderState } from './custom-loader.model';

@Injectable()
export class EguardCustomLoaderService {
public loaderSubject: Subject<LoaderState> = new Subject<LoaderState>();

loaderState = this.loaderSubject.asObservable();


constructor() { }
show() {
        this.loaderSubject.next(<LoaderState>{show: true});
    }
hide() {
        this.loaderSubject.next(<LoaderState>{show: false});
    }z;
}



// WEBPACK FOOTER //
// ./src/app/core/components/custom-loader/custom-loader.service.ts